import React, { useState } from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import "./ThreeCard.css";
import "../../Homepage/BusinessTravel/BusinessTravel.css";
import "../../Coporate-travel-management/TravelServices/TravelServices.css";
import Modal from "../../../Pages/ModalForm";
import Heading from "../../../utls/Heading";

const ThreeCard = () => {
  const [showModal, setShowModal] = useState(false);

  const handleShow = () => {
    setShowModal(true);
  };
  const handleClose = () => setShowModal(false);
  return (
    <>
      <div className="container three-card-section mt-5 pt-md-5 px-lg-5 ps-md-5">
        <div className="row">
          <div className="col-md-12 mt-md-3">
            <p className="text-center light-small-p">
              With our expertise in travel industry and leisure travel
              experiences,
            </p>
            <p className="dark-big-p text-center">
              We will customize your holiday package to suit your preferences,
              whether in getaways or destinations.
            </p>
          </div>

          <div className="row px-lg-5  ps-md-0 mlTab business-travel-section margintop mt-3">
            <div className="col-lg-4 col-md-4 col-12  d-flex justify-content-center">
              <div className="BT-box bt-three-box shadow">
                <div className="row">
                  <div className="col-md-12 radius-image">
                    <LazyLoadImage
                      effect="blur"
                      src="https://blueberrywebsites.azureedge.net/bbt/images/ThreeCard1.png"
                      alt=""
                      className="w-100 h-100 img-fluid"
                      loading="lazy"
                    />
                  </div>
                  <div className="col-md-12 p-4">
                    <h5 className="fw-bold">Concierge Services</h5>
                    <p className="mt-3">
                      From restaurant bookings to tour arrangements and lost
                      luggage assistance, our team takes care of it as required.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-4 col-12 d-flex justify-content-center">
              <div className="BT-box bt-three-box shadow">
                <div className="row">
                  <div className="col-md-12 radius-image">
                    <LazyLoadImage
                      effect="blur"
                      src="https://blueberrywebsites.azureedge.net/bbt/images/ThreeCard2.png"
                      alt=""
                      className="w-100 h-100 img-fluid"
                      loading="lazy"
                    />
                  </div>
                  <div className="col-md-12 p-4">
                    <h5 className="fw-bold">Visa and Passport</h5>
                    <p className="mt-3">
                      Travelling internationally? Let us handle the logistics of
                      visa and passport coordination, so you can focus on your
                      adventure!
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-4 col-12  d-flex justify-content-center">
              <div className="BT-box bt-three-box shadow">
                <div className="row">
                  <div className="col-md-12 radius-image">
                    <LazyLoadImage
                      effect="blur"
                      src="https://blueberrywebsites.azureedge.net/bbt/images/ThreeCard3.png"
                      alt=""
                      className="w-100 h-100 img-fluid"
                      loading="lazy"
                    />
                  </div>
                  <div className="col-md-12 p-4">
                    <h5 className="fw-bold">Planning Your Itinerary</h5>
                    <p className="mt-3">
                      Enjoy a unique travel experience with a personalized
                      itinerary that perfectly aligns with your interests,
                      budget, and schedule.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* .....elevate travel section.............. */}
      <section className=" travelboy">
        <div className="container">
          <div className="row">
            <div className="col-md-6">
              <Heading className="headings text-white mt-2">
                <span>Upgrade Your BLeisure </span>Travel Experience Today!
              </Heading>
              <div className="carouselCaption mt-md-3 mt-xxl-5 upgrade-btn">
                <button
                  className="btn fs4 fw-bold bg-transparent text-white text-uppercase leeter"
                  type="submit"
                  onClick={handleShow}
                >
                  LET’S EXPLORE
                </button>
              </div>
            </div>
            <div className="col-md-6">
              <div className="upgrade-img  d-flex justify-content-center align-items-center">
                <LazyLoadImage
                  src="https://blueberrywebsites.azureedge.net/bbt/images/travelboy.png"
                  alt=""
                  loading="lazy"
                />
              </div>
            </div>
          </div>
        </div>
      </section>
      <Modal show={showModal} handleClose={handleClose} />
    </>
  );
};

export default ThreeCard;
